import { Switch, Route } from "react-router-dom";
import { ArchivesProvider } from "../contexts/archives-context";
import { BanksProvider } from "../contexts/banks-context";
import { CommentsProvider } from "../contexts/comments-context";
import { ConfigurationsContextProvider } from "../contexts/configurations-context";
import { CustomerProvider } from "../contexts/customer-context";
import { ServiceCustomerProvider } from "../contexts/service-customer-context";
import { UserProvider } from "../contexts/user-context";
import ListTributaryScreenings from "../components/tributary-screening/list-tributary-screenings";

const TributaryScreening = ({ match }) => {
  return (
    <div className="screenings-page">
      <CustomerProvider>
        <CommentsProvider>
          <BanksProvider>
            <ArchivesProvider>
              <UserProvider>
                <ServiceCustomerProvider>
                  <ConfigurationsContextProvider>
                    <Switch>
                      <Route
                        exact
                        path={`${match.path as string}`}
                        component={ListTributaryScreenings}
                      />
                    </Switch>
                  </ConfigurationsContextProvider>
                </ServiceCustomerProvider>
              </UserProvider>
            </ArchivesProvider>
          </BanksProvider>
        </CommentsProvider>
      </CustomerProvider>
    </div>
  );
};

export default TributaryScreening;
